import { i18nMark } from 'lingui-react';

import buildEnum from 'utils/buildEnum';

export const notificationType = buildEnum([
  'dispatched',
  'rolling',
  'poNumber',
]);

export const notificationTypeLabel = {
  [notificationType.dispatched]: i18nMark('Dispatched'),
  [notificationType.rolling]: i18nMark('Vehicle Rolling'),
  [notificationType.poNumber]: i18nMark('USX PO - Dispatched'),
};



// WEBPACK FOOTER //
// ./src/compositions/CaseActivityPanel/NotificationHistory/constants.js